import '@appPath/encoders/encode-xml.js'
import '@appPath/helpers/browser/useragent.js'
import '@appPath/downloaders/downloader.js'
import 'bootstrap/dist/js/bootstrap.bundle.js'

/* 
   The tag for version 1.5.3 was never created, the latest (and only) version available is 1.5.1
   Instead of installing an older version, I'll just stick with local unmanaged x-editable. Hopefully the only exception
*/
import '@libPath/bootstrap/bootstrap-editable/js/bootstrap-editable.js'

// Dynamically import all locale files
const context = require.context(
   'bootstrap-datepicker/js/locales', // Path to locales directory
   false,                            // Do not recurse into subdirectories
   /\.js$/                           // Match all `.js` files
);

// Load em
context.keys().forEach(context);

/* This version does not exist in npm. Those don't work with our code so there's some refactoring to do before they can be used */
import '@libPath/bootstrap/bootstrap-notify/bootstrap-notify.js'

import 'jspdf'
import '@appPath/validators/validator.js'
import '@appPath/converters/default-value-converter.js'
import '@appPath/sorters/default-sorter.js'
import '@appPath/sorters/document-sorter.js'
import '@appPath/converters/formatter.js'
import 'bootstrap-table/dist/bootstrap-table.js';
import 'bootstrap-table/dist/bootstrap-table-locale-all.js';
import 'bootstrap-table/dist/extensions/sticky-header/bootstrap-table-sticky-header.js';
import 'bootstrap-table/dist/extensions/export/bootstrap-table-export.js';
import 'tableexport.jquery.plugin';


import 'bootstrap-table/dist/extensions/editable/bootstrap-table-editable.js';
import '@appPath/entities/editables/editable-data-container.js';
import '@appPath/entities/editables/table-editable-data.js';
import '@appPath/entities/editables/table-editable-item.js';


